module.exports = function(angular, app) {
    var ColumnTypes = require('../columns').ColumnTypes;
    var ColumnTypesList = require('../columns').ColumnTypesList;

    function deepQuerySelect($filter, DeepQueryDimensions) {
        return {
            restrict: 'E',
            scope: {
                columns: '=bindSelect',
                source: '='
            },
            templateUrl: '/tpl/deep-query/select.html',
            link: function link(scope, element, attrs) {
                scope.columnTypes = ColumnTypes;
                scope.columnTypesList = ColumnTypesList;

                var columnType = scope.columnType = function columnType(column) {
                    return column._type || (column._type = ColumnTypes[column.type]);
                };

                scope.columnTypeName = function columnName(column) {
                    return columnType(column).name;
                };

                function makeColumn(type, parent) {
                    if (!type) return null;
                    var column = angular.copy(type.template);
                    column._type = type;
                    if (parent)
                        column.parent = parent;
                    else
                        column.name = "";
                    return column;
                }

                scope.addColumn = function addColumn(type, parent) {
                    var args = parent ? parent.args : scope.columns;
                    var column = makeColumn(type, parent);
                    args.push(column);
                };

                function filterIndex(column, children) {
                    for(var i = children.length; i-- > 0; )
                        if (children[i] === column)
                            return i;
                };

                scope.removeColumn = function removeColumn(column) {
                    var children = column.parent ? column.parent.args : scope.columns;
                    var index = filterIndex(column, children);
                    if (index != null)
                        children.splice(index, 1);
                };

                scope.changeColumnType = function changeColumnType(type, column) {
                    if (type.id == column.type)
                        return;
                    var template = type.template;
                    column.type = template.type;
                    delete column._type;
                    for(var name in template) {
                        if (typeof column[name] !== typeof template[name])
                            column[name] = angular.copy(template[name]);
                    }
                    for(var name in column) {
                        if (name !== 'name' && !(name in template))
                            delete column[name];
                    }
                };

                scope.hasRegex = function hasRegex(column) {
                    return angular.isDefined(columnType(column).template.regex);
                };

                scope.hasField = function hasField(column) {
                    return angular.isDefined(columnType(column).template.field);
                };

                scope.hasFilter = function hasFilter(column) {
                    return angular.isDefined(column.filter);
                };

                scope.hasArgs = function hasArgs(column) {
                    return angular.isArray(column.args);
                };

                scope.hasValue = function hasValue(column) {
                    return angular.isDefined(columnType(column).template.value);
                };

                scope.hasRef = function hasRef(column) {
                    return angular.isDefined(columnType(column).template.ref);
                };

                var isRootType = scope.isRootType = function isRootType(type) {
                    return !type.noRootField;
                };

                var isSubfieldType = scope.isSubfieldType = function isSubfieldType(type) {
                    return !type.noSubField;
                };

                scope.selectColumnTypesList = function selectColumnTypesList(column) {
                    if (column.parent) {
                        return $filter('filter')(ColumnTypesList, isSubfieldType);
                    } else {
                        return $filter('filter')(ColumnTypesList, isRootType);
                    }
                };

                scope.taDimensions = function taDimensions(viewValue) { // TODO: export to separate directive
                    return DeepQueryDimensions.getNamesFiltered(scope.source, viewValue, 3);
                };


            }
        };
    }

    app.directive('deepQuerySelect', ['$filter', 'DeepQueryDimensions', deepQuerySelect]);
};
